<h5>Programas Permitidos Por Cestas para Operações de Repasse</h5>

<section class="pesquisa">
  <div class="container">
    <form class="mt-3 mx-auto">
      <div class="mb-3 row">
        <div class="col">
          <h3>Pesquisa</h3>
        </div>
        <div class="col-auto" *ngIf="podeCadastrar">
          <button class="btn btn-primary no-margin" type="button"
            (click)="abrirModalCadastro('Modal com body sendo uma template', 'lg', true, true);"
            ngbTooltip="Tela para cadastro de programa permitido por cesta."><i
              class="fa fa-file-signature">
            </i> Cadastrar Novo Programa</button>
        </div>
        <div class="col-auto" *ngIf="podeCadastrar">
          <button class="btn btn-primary no-margin" type="button"
            ngbTooltip="Tela para habilitar programa permitido por cesta." [disabled]="!ideTranche" [routerLink]="['habilitacao-programa', ideTranche]"><i
              class="fa fa-file-signature">
            </i> Habilitar Novo Programa</button>
        </div>
        <div class="col-auto">
          <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
        </div>
        <div class="col-auto" *ngIf="ideTranche == null; else podePesquisar">
          <button disabled type="button" class="btn btn-success no-margin">
            Pesquisar</button>
        </div>
        <ng-template #podePesquisar>
          <div class="col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="buscarTodosPorTranche()">
              Pesquisar</button>
          </div>
        </ng-template>
      </div>
    </form>

    <div class="bn-form-group row">
      <div class="col-md-5">
        <label for="tranche">Cesta: </label>
        <select id="tranche" class="form-select" [(ngModel)]="ideTranche" (change)="buscaTranche()">
          <option [ngValue]=null></option>
          <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
            {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
        </select>
      </div>
    </div>
  </div>
</section>

<ng-template #bodyHabilitacao>
  <div class="row">

    <div class="bn-form-group col-md-4">
      <label><b>Código</b></label>
      <ng-select
        id="codigo"
        [(ngModel)]="codigo"
        [items]="dominioProgramas"
        bindLabel="id"
        bindValue="id"
        placeholder="Selecione">
      </ng-select>
    </div>

    <div *ngIf="modalidade.utilizaIndicadorEscoParaProgramasAceitos" class="bn-form-group col-md-4 esco">
      <label><b> ESCO&ensp;</b>
        <i class="fa fa-question-circle help-subtitulo" placement="top-right"></i></label>
      <input class="form-check checkbox-gigante" type="checkbox" id="esco" [(ngModel)]="esco">
    </div>
  </div>

</ng-template>
<ng-template #botoesHabilitacao>
  <button class="btn btn-danger" (click)="close()">Fechar</button>
  <button class="btn btn-success" (click)="salvarHabilitar()" [disabled]="codigo == null || codigo == undefined">Salvar</button>
</ng-template>

<ng-template #bodyCadastro>
  <div class="row">

    <div class="bn-form-group col-md-5">
      <label><b>Código</b></label>
      <input type="number"
        class="form-control"
        id="codigo"
        [(ngModel)]="codigo"
        required>
    </div>

    <div class="bn-form-group col-md-7">
      <label><b>Descrição do programa</b></label>
      <input type="text"
        class="form-control"
        id="descricao"
        [(ngModel)]="descricao"
        maxlength="100"
        required>
    </div>
  </div>

</ng-template>
<ng-template #botoesCadastro>
  <button class="btn btn-danger" (click)="close()">Fechar</button>
  <button class="btn btn-success" (click)="salvarCadastrar()" [disabled]="(codigo == null || codigo == undefined) || (descricao == null || descricao == undefined)">Salvar</button>
</ng-template>

<app-programas-permitidos-por-cestas-listagem
  [programasPermitidos]="programasPermitidos"
  [ideTranche]="ideTranche"
  [permissaoGestorEnvio]="podeCadastrar"
  *ngIf="pesquisado">
</app-programas-permitidos-por-cestas-listagem>
